module ConfigService {
    export interface IConfigService {
        setBaseServicesUrl: (baseServicesUrl: string) => void;
        setActiveTemplate: (templateKey: string, templateValue: string) => void;
        setService: (serviceKey: string, serviceValue: string) => void;
        resolveServiceUrl: (serviceKey: string) => string;
        setAdClientId: (adClientId: string) => void;
        getAdClientId: () => string;
    };

    export interface IConfigData {
        baseServicesUrl: string;
        templates: { [key: string]: string };
        services: { [key: string]: string };
        adClientId: string;
    };

    export class CConfigService implements IConfigService {
        constructor(
            protected $sessionStorage: any,
            protected $timeout: angular.ITimeoutService,
            protected $translate: angular.translate.ITranslateService,
            protected GlobalApplicationData: any,
            protected jwtHelper: any,
            protected $resource: ng.resource.IResourceService,
            protected $q: angular.IQService
        ) {
            $sessionStorage.isConfigServiceInitialized = false;

            $sessionStorage.configData = <IConfigData>{
                templates: {},
                services: {}
            };

        };

        public init = (forceReload: boolean = false): Promise<void> => {
            if (!forceReload && this.$sessionStorage.isConfigServiceInitialized) {
                return this.$q.resolve();
            }

            let _self = this;

            let xhr = new XMLHttpRequest();
            xhr.open("GET", _self.GlobalApplicationData.applicationContext + "config.json", false);
            xhr.send();

            let responseStatus = xhr.status;

            console.log("xhr config.json response status:", responseStatus);

            let responseText = xhr.responseText;

            console.log("xhr config.json response text:", responseText);

            if (responseText && responseStatus === 200) {
                let configData = <IConfigData>JSON.parse(responseText);

                if (configData.templates) {
                    for (let activeTemplateKey in configData.templates) {
                        _self.setActiveTemplate(activeTemplateKey, configData.templates[activeTemplateKey]);
                    }
                }
                if (configData.baseServicesUrl) {
                    _self.setBaseServicesUrl(configData.baseServicesUrl);
                }
                if (configData.services) {
                    for (let serviceKey in configData.services) {
                        _self.setService(serviceKey, configData.services[serviceKey]);
                    }
                }
                if (configData.adClientId) {
                    _self.setAdClientId(configData.adClientId);
                }
            } else {
                console.error("error on config.json response");
            }
        };

        public setBaseServicesUrl = (baseServicesUrl: string): void => {
            this.$sessionStorage.configData.baseServicesUrl = baseServicesUrl;
        };

        public setActiveTemplate = (templateKey: string, templateValue: string): void => {
            this.$sessionStorage.configData.templates[templateKey] = templateValue;
        };

        public getActiveTemplate = (templateKey: string): string => {
            return this.$sessionStorage.configData.templates ? this.$sessionStorage.configData.templates[templateKey] : null;
        };

        public setService = (serviceKey: string, serviceValue: string): void => {
            this.$sessionStorage.configData.services[serviceKey] = serviceValue;
        };

        public resolveServiceUrl = (serviceKey: string): string => {
            let serviceUrl = this.$sessionStorage.configData.baseServicesUrl;

            if (serviceUrl.substr(serviceUrl.length - 1) !== "/") {
                serviceUrl += "/";
            }

            let serviceValue = this.$sessionStorage.configData.services[serviceKey];
            if (serviceValue) {
                if (serviceValue.substr(0, 1) === "/") {
                    serviceValue = serviceValue.substr(1);
                }

                serviceUrl += serviceValue;
            } else {
                throw new Error("service key not found on services");
            }

            return serviceUrl;
        };

        public setAdClientId = (adClientId: string): void => {
            this.$sessionStorage.configData.adClientId = adClientId;
        };

        public getAdClientId = (): string => {
            return this.$sessionStorage.configData.adClientId;
        };
    };

    // registro la factory
    angular.module("CustPortalApp").factory("ConfigService", ($sessionStorage: any, $timeout: angular.ITimeoutService, $translate: angular.translate.ITranslateService, GlobalApplicationData: any, jwtHelper: any, $resource: ng.resource.IResourceService, $q: angular.IQService) => new ConfigService.CConfigService($sessionStorage, $timeout, $translate, GlobalApplicationData, jwtHelper, $resource, $q));
}
